import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { itemService } from '../services/api';

const JoinFamily = () => {
    const [formData, setFormData] = useState({
        first_name: '', 
        email: '', 
        password: '', 
        invite_code: ''
    });
    
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const codeFromUrl = searchParams.get('code');
        if (codeFromUrl) {
            setFormData(prev => ({ ...prev, invite_code: codeFromUrl }));
        }
    }, [searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // Harmonisation avec l'API (name au lieu de first_name)
            const payload = {
                name: formData.first_name,
                email: formData.email,
                password: formData.password,
                inviteCode: formData.invite_code
            };

            const response = await itemService.joinFamily(payload);
            const data = await response.json();

            if (response.ok) {
                alert("Inscription réussie ! Vous pouvez maintenant vous connecter.");
                navigate('/login');
            } else {
                setError(data.message || "Code invalide ou erreur d'inscription.");
            }
        } catch (error) {
            setError("Erreur de connexion au serveur.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
            <Card className="border-0 shadow-lg rounded-4 p-3" style={{ maxWidth: '400px', width: '100%' }}>
                <Card.Body>
                    <div className="text-center mb-4">
                        <h2 className="fw-bold text-success">Rejoindre Shopali</h2>
                        <p className="text-muted">Entrez le code de votre famille</p>
                    </div>

                    {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Code d'invitation</Form.Label>
                            <Form.Control 
                                type="text" 
                                className="bg-light border-0 fw-bold text-center"
                                style={{ letterSpacing: '3px' }}
                                placeholder="EX: A1B2C3"
                                value={formData.invite_code}
                                onChange={(e) => setFormData({...formData, invite_code: e.target.value.toUpperCase()})}
                                required 
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Votre Prénom</Form.Label>
                            <Form.Control 
                                type="text" 
                                className="bg-light border-0"
                                value={formData.first_name}
                                onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                                required 
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Email</Form.Label>
                            <Form.Control 
                                type="email" 
                                className="bg-light border-0"
                                value={formData.email}
                                onChange={(e) => setFormData({...formData, email: e.target.value})}
                                required 
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="small fw-bold">Mot de passe</Form.Label>
                            <Form.Control 
                                type="password" 
                                className="bg-light border-0"
                                value={formData.password}
                                onChange={(e) => setFormData({...formData, password: e.target.value})}
                                required 
                            />
                        </Form.Group>

                        <Button variant="success" type="submit" className="w-100 rounded-pill fw-bold py-2 shadow-sm mb-3" disabled={loading}>
                            {loading ? 'Vérification...' : 'Rejoindre la famille'}
                        </Button>

                        <div className="text-center">
                            <Button variant="link" onClick={() => navigate('/login')} className="text-muted small text-decoration-none">
                                Retour à la connexion
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default JoinFamily;